import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogBuckets } from "../../repositories/CatalogBucketRepository";
import { useBucketContext } from "./CatalogBucketContext";
import { TableBucket } from "./components/BucketTable";

type Props = {};
export const BucketPage = (props: Props) => {
	const { state, actions } = useBucketContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getBucketsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogBuckets();
		if (resp.ok) {
			actions.setBuckets(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getBucketsFromAPI();
	}, []);

	if (state.buckets) {
		return (
			<>
				<HelmetDexteel title="Buckets - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableBucket
								isLoading={isLoading}
								getBucketsFromAPI={getBucketsFromAPI}
							/>
						</Paper>
					</Grid>
					<ErrorModal error={error} onHide={() => setError("")} />
				</Grid>
			</>
		);
	}

	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
